import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { submitContactForm } from "../../Api/Users/Home/ContactUs";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axiosInstance from "../../axiosInstance";
import AOS from "aos";
import "aos/dist/aos.css";

const Contact = () => {
  const { t, i18n } = useTranslation();
  const languageDirection = i18n.language === "ar" ? "rtl" : "ltr";
  const faqList = t("faq.items", { returnObjects: true });
  const [contactTypes, setContactTypes] = useState([]);

  useEffect(() => {
    AOS.init({ duration: 1000 });
    // جلب أنواع التواصل
    const fetchContactTypes = async () => {
      try {
        const response = await axiosInstance.get(
          "/api/v1/lookups/contact-us-types"
        );
        console.log("Contact Types Response:", response.data); // ✨ أضيفي هذا
        setContactTypes(response.data?.items || []);
      } catch (error) {
        console.error("Failed to fetch contact types", error);
      }
    };

    fetchContactTypes();
  }, []);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    description: "",
    contactUsType: "",
  });

  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    toast.dismiss();
    setIsLoading(true);

    const { name, email, contactUsType, description } = formData;

    if (!name || !email || !contactUsType || !description) {
      toast.error(t("contact_Us.form.errorEmptyFields"));
      setIsLoading(false);
      return;
    }

    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    if (!emailPattern.test(email)) {
      toast.error(t("contact_Us.form.errorInvalidEmail"));
      setIsLoading(false);
      return;
    }

    try {
      await submitContactForm({
        name,
        email,
        description,
        contactUsType: parseInt(contactUsType),
      });
      toast.success(t("contact_Us.form.successMessage"));
      setFormData({
        name: "",
        email: "",
        description: "",
        contactUsType: "",
      });
    } catch (error) {
      toast.error(t("contact_Us.form.errorMessage"));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div dir={languageDirection}>
      {/* Header */}
      <section className="bg-light py-5">
        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center">
              <h1 className="fw-bold text-primary-custom mb-3">
                {t("contact_Us.title")}
              </h1>
              <p className="lead mb-0">{t("contact_Us.subtitle")}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form + Info */}
      <section className="py-5">
        <div className="container py-4">
          <div className="row">
            {/* Form */}
            <div className="col-lg-6 mb-5 mb-lg-0" data-aos="fade-up">
              <h3 className="fw-bold text-primary-custom mb-4">
                {t("contact_Us.sendMessage")}
              </h3>
              <p className="text-muted mb-4">{t("contact_Us.messageNote")}</p>

              <form onSubmit={handleSubmit}>
                <div className="row g-3">
                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        placeholder={t("contact_Us.form.name")}
                        required
                      />
                      <label>{t("contact_Us.form.name")}</label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        placeholder={t("contact_Us.form.email")}
                        required
                      />
                      <label>{t("contact_Us.form.email")}</label>
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div className="form-floating">
                      <select
                        className="form-select"
                        name="contactUsType"
                        value={formData.contactUsType}
                        onChange={handleInputChange}
                        required
                      >
                        <option value="">
                          {t("contact_Us.form.selectDepartment")}
                        </option>
                        {contactTypes.map((type) => (
                          <option key={type.id} value={type.id}>
                            {type.name}
                          </option>
                        ))}
                      </select>
                      <label>{t("contact_Us.form.department")}</label>
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div className="form-floating">
                      <textarea
                        className="form-control"
                        name="description"
                        value={formData.description}
                        onChange={handleInputChange}
                        placeholder={t("contact_Us.form.message")}
                        style={{ height: 150 }}
                        required
                      ></textarea>
                      <label>{t("contact_Us.form.message")}</label>
                    </div>
                  </div>

                  <div className="col-12">
                    <button
                      type="submit"
                      className="btn btn-primary btn-lg w-100"
                      disabled={isLoading}
                    >
                      {isLoading
                        ? t("contact_Us.form.sending")
                        : t("contact_Us.form.send")}
                    </button>
                  </div>
                </div>
              </form>
            </div>

            {/* contact_Us Info */}
            <div className="col-lg-5 offset-lg-1" data-aos="fade-left">
              <h3 className="fw-bold text-primary-custom mb-4">
                {t("contact_Us.contactInfo")}
              </h3>
              <p className="text-muted mb-4">{t("contact_Us.reachUs")}</p>

              <div className="d-flex mb-4">
                <i className="fas fa-map-marker-alt fa-2x text-primary-custom me-3"></i>
                <div>
                  <h5 className="fw-bold mb-1">{t("contact_Us.address")}</h5>
                  <p className="text-muted mb-0">
                    {t("contact_Us.addressDetails")}
                  </p>
                </div>
              </div>

              <div className="d-flex mb-4">
                <i className="fas fa-phone-alt fa-2x text-primary-custom me-3"></i>
                <div>
                  <h5 className="fw-bold mb-1">{t("contact_Us.phone")}</h5>
                  <p className="text-muted mb-0">
                    <a
                      href="tel:+966112345678"
                      className="text-decoration-none text-muted"
                    >
                      +966 11 234 5678
                    </a>
                  </p>
                </div>
              </div>

              <div className="d-flex mb-4">
                <i className="fas fa-envelope fa-2x text-primary-custom me-3"></i>
                <div>
                  <h5 className="fw-bold mb-1">{t("contact_Us.email")}</h5>
                  <p className="text-muted mb-0">
                    <a
                      href="mailto:info@speakers.sa"
                      className="text-decoration-none text-muted"
                    >
                      info@speakers.sa
                    </a>
                    <br />
                    <a
                      href="mailto:support@speakers.sa"
                      className="text-decoration-none text-muted"
                    >
                      support@speakers.sa
                    </a>
                  </p>
                </div>
              </div>

              <div className="d-flex mb-4">
                <i className="fas fa-clock fa-2x text-primary-custom me-3"></i>
                <div>
                  <h5 className="fw-bold mb-1">{t("contact_Us.hours")}</h5>
                  <p className="text-muted mb-0">
                    {t("contact_Us.hoursDetails")}
                  </p>
                </div>
              </div>

              <div className="mt-4">
                <h5 className="fw-bold mb-3">{t("contact_Us.followUs")}</h5>
                <div className="social-links">
                  <a
                    href="https://x.com/mutahadithun?mx=2"
                    className="btn btn-outline-secondary me-2"
                  >
                    <i className="fa-brands fa-x-twitter">x</i>
                  </a>
                  <a
                    href="https://www.facebook.com/share/15umnQx72v/?mibextid=wwXIfr"
                    className="btn btn-outline-secondary me-2"
                  >
                    <i className="fab fa-facebook-f"></i>
                  </a>
                  {/* <a href="#" className="btn btn-outline-secondary me-2"><i className="fab fa-instagram"></i></a> */}
                  <a
                    href="https://www.linkedin.com/company/speakers-platform/posts/?feedView=all"
                    className="btn btn-outline-secondary me-2"
                  >
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                  {/* <a href="#" className="btn btn-outline-secondary"><i className="fab fa-youtube"></i></a> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-5 bg-light">
        <div className="container py-4">
          <div className="row justify-content-center mb-5">
            <div className="col-lg-8 text-center">
              <h2 className="fw-bold text-primary-custom mb-3">
                {t("mapSection.title")}
              </h2>
              <p className="text-muted">{t("mapSection.subtitle")}</p>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="map-container shadow-sm mb-3">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3623.217651787121!2d46.62330427534076!3d24.757239778032983!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e2f02ed96025be5%3A0xc41e18dc72aaf6fc!2z2KfZhNi02KfYs9mK2Kkg2KfZhNio2YrYqSDYp9mE2YXYs9mK2YbZitmK2YQ!5e0!3m2!1sar!2ssa!4v1713711528294!5m2!1sar!2ssa"
                  width="100%"
                  height="400"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                ></iframe>
              </div>
              <p className="text-center text-muted">
                📍{" "}
                <a
                  href="https://maps.app.goo.gl/RPxQY9rnPe8tz6dD7?g_st=iw"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  {t("location.yu")}
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* الاسئلة الشائعة */}
      <section className="py-5">
        <div className="container py-4">
          <div className="row justify-content-center mb-5">
            <div className="col-lg-8 text-center">
              <h2 className="fw-bold text-primary-custom mb-3">
                {t("faq.title")}
              </h2>
              <p className="text-muted">{t("faq.subtitle")}</p>
            </div>
          </div>

          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="accordion" id="faqAccordion">
                {faqList.map((item, index) => (
                  <div className="accordion-item" key={index}>
                    <h2 className="accordion-header" id={`heading${index}`}>
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#collapse${index}`}
                        aria-expanded="false"
                        aria-controls={`collapse${index}`}
                      >
                        {item.question}
                      </button>
                    </h2>
                    <div
                      id={`collapse${index}`}
                      className="accordion-collapse collapse"
                      aria-labelledby={`heading${index}`}
                      data-bs-parent="#faqAccordion"
                    >
                      <div className="accordion-body">{item.answer}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
      <ToastContainer />
    </div>
  );
};

export default Contact;
